import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Link, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import CookieBanner from "@/components/layout/CookieBanner";
import MobileCTA from "@/components/layout/MobileCTA";
import HomePage from "@/pages/HomePage";
import RealisationsPage from "@/pages/RealisationsPage";
import VideosPage from "@/pages/VideosPage";
import ProjectDetailPage from "@/pages/ProjectDetailPage";
import ServicesPage from "@/pages/ServicesPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";
import LegalPage from "@/pages/LegalPage";
import PrivacyPage from "@/pages/PrivacyPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const NotFound = () => (
  <div className="flex min-h-[70vh] flex-col items-center justify-center gap-6 px-5 pt-20" data-testid="not-found-page">
    <p className="font-display text-7xl font-extrabold text-bati-sky">404</p>
    <h1 className="font-display text-2xl font-bold text-bati-ink">Cette page n'existe pas.</h1>
    <Link to="/" className="bg-bati-blue px-6 py-3 text-[13px] font-bold uppercase tracking-[0.12em] text-white transition-colors hover:bg-bati-sky">
      Retour à l'accueil
    </Link>
  </div>
);

const Chrome = ({ children }) => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) {
    return <main>{children}</main>;
  }
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      <MobileCTA />
      <CookieBanner />
    </>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Chrome>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/realisations" element={<RealisationsPage />} />
          <Route path="/videos" element={<VideosPage />} />
          <Route path="/realisations/:slug" element={<ProjectDetailPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/a-propos" element={<AboutPage />} />
          <Route path="/about/*" element={<Navigate to="/a-propos" replace />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/mentions-legales" element={<LegalPage />} />
          <Route path="/politique-confidentialite" element={<PrivacyPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Chrome>
      <Toaster position="top-center" />
    </BrowserRouter>
  );
}

export default App;
